import React from "react";
import Typography from "@pagepro-monorepo/ui/lib/components/styles/Typography";
import Button from "@pagepro-monorepo/ui/lib/components/atoms/Button";

import IconArrowRight from "@assets/svg/arrow-right.svg";

import { CHECKPOINT_ICONS } from "./icons";
import * as Styled from "./styles";

interface IntroPhaseProps {
  onStart: () => void;
}

const CHECKPOINTS = [
  "Security exposure",
  "Deployment maturity",
  "Testing coverage",
  "Architecture scalability",
  "Business readiness"
];

const OUTCOMES = [
  "Your maturity stage",
  "Risk level",
  "Clear recommended next step"
];

const IntroPhase: React.FC<IntroPhaseProps> = ({ onStart }) => (
  <div>
    <Typography variant="subheading2" as="p" mb="1rem">
      What we assess
    </Typography>

    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem",
        marginBottom: "2.5rem"
      }}
    >
      <div
        style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}
      >
        {CHECKPOINTS.slice(0, 3).map((item) => (
          <Styled.BlockPill key={item} $isActive={false}>
            {CHECKPOINT_ICONS[item] &&
              React.createElement(CHECKPOINT_ICONS[item])}
            <Styled.BlockPillText>{item}</Styled.BlockPillText>
          </Styled.BlockPill>
        ))}
      </div>
      <div
        style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}
      >
        {CHECKPOINTS.slice(3).map((item) => (
          <Styled.BlockPill key={item} $isActive={false}>
            {CHECKPOINT_ICONS[item] &&
              React.createElement(CHECKPOINT_ICONS[item])}
            <Styled.BlockPillText>{item}</Styled.BlockPillText>
          </Styled.BlockPill>
        ))}
      </div>
    </div>

    <Typography variant="subheading2" as="p" mb="1rem">
      You receive
    </Typography>

    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem",
        marginBottom: "2.5rem"
      }}
    >
      {OUTCOMES.map((item) => (
        <Styled.IntroOutcome key={item}>{item}</Styled.IntroOutcome>
      ))}
    </div>

    <Button $mode="tertiary" icon={IconArrowRight} onClick={onStart}>
      Start Assessment
    </Button>

    <Styled.Footnote style={{ marginTop: "1.5rem" }}>
      15 questions. No account required. Results are instant.
    </Styled.Footnote>
  </div>
);

export default IntroPhase;
